/**
 * Utility to handle image URLs and fallbacks
 */

export const DEFAULT_PLACEHOLDER = 'https://images.unsplash.com/photo-1614850523296-d8c1af93d400?q=80&w=800&auto=format&fit=crop';

export const getImageUrl = (path) => {
    if (!path) return DEFAULT_PLACEHOLDER;
    
    // If it's already a full URL (Cloudinary or Unsplash), return it
    if (path.startsWith('http')) return path;
    
    // If it's a relative path (e.g. from local uploads fallback), prefix with API URL
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    const baseUrl = apiUrl.replace('/api', '');
    return `${baseUrl}/${path.replace(/^\/+/, '')}`;
};

export const handleImageError = (e) => {
    e.target.src = DEFAULT_PLACEHOLDER;
};
